import React from 'react';
import {Box} from '@mui/material';
import {CARTE} from '../../tokens.js';

// Squelette de `FichePAV-Chargement.dc.html` (valeurs de la maquette, y compris les formes en pilule des blocs photo).
const carteSx = {bgcolor: CARTE.fond, border: `1px solid ${CARTE.bordure}`, borderRadius: `${CARTE.radius}px`, boxShadow: CARTE.ombre};

function Barre({l, h, fond = '#E6EAEE', r = '6px'}) {
    return <Box sx={{width: l, height: h, bgcolor: fond, borderRadius: r, flex: 'none', maxWidth: '100%'}}/>;
}

function ChampSquelette({largeur}) {
    return (
        <Box sx={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
            <Barre l={80} h={10} fond="#F0F2F5"/>
            <Barre l={largeur} h={14}/>
        </Box>
    );
}

function LigneSquelette() {
    return (
        <Box sx={{display: 'flex', gap: '16px', alignItems: 'center'}}>
            <Barre l={90} h={12}/>
            <Barre l={120} h={22} r="999px"/>
            <Box sx={{flex: 1, height: 12, bgcolor: '#F0F2F5', borderRadius: '6px'}}/>
        </Box>
    );
}

export default function FicheSquelette() {
    return (
        <Box aria-busy="true" aria-label="Chargement de la fiche" sx={{display: 'flex', flexDirection: 'column', gap: '24px'}}>
            <Box component="section" sx={{...carteSx, display: 'flex', gap: '32px', px: '28px', py: '24px', flexWrap: 'wrap'}}>
                <Box sx={{flex: '1 1 560px', display: 'flex', flexDirection: 'column', gap: '18px'}}>
                    <Box sx={{display: 'flex', gap: '20px', alignItems: 'flex-end'}}>
                        <Box sx={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                            <Barre l={150} h={12}/>
                            <Barre l={220} h={34} fond="#DDE2E8" r="999px"/>
                            <Barre l={320} h={14}/>
                        </Box>
                        <Box sx={{display: 'flex', gap: '10px', pb: '20px'}}>
                            <Barre l={120} h={28} r="999px"/>
                            <Barre l={180} h={28} r="999px"/>
                        </Box>
                    </Box>
                    <Box sx={{display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: '18px 24px', pt: '16px', borderTop: `1px solid ${CARTE.separateur}`}}>
                        {[110, 60, 90, 50, 100, 100, 70, 140].map((l, i) => <ChampSquelette key={i} largeur={l}/>)}
                    </Box>
                </Box>
                <Box sx={{flex: '0 0 320px', maxWidth: '100%', height: 180, bgcolor: '#E6EAEE', borderRadius: '999px'}}/>
            </Box>

            <Box sx={{display: 'flex', gap: '24px', flexWrap: 'wrap', alignItems: 'flex-start'}}>
                <Box sx={{flex: '999 1 640px', minWidth: 0, display: 'flex', flexDirection: 'column', gap: '24px'}}>
                    <Box component="section" sx={{...carteSx, px: '24px', py: '16px', display: 'flex', flexDirection: 'column', gap: '16px'}}>
                        <Barre l={160} h={16} fond="#DDE2E8"/>
                        <Box sx={{display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: '12px'}}>
                            <Box sx={{aspectRatio: '4 / 3', bgcolor: '#E6EAEE', borderRadius: '999px'}}/>
                            <Box sx={{aspectRatio: '4 / 3', bgcolor: '#E6EAEE', borderRadius: '999px'}}/>
                        </Box>
                    </Box>
                    <Box component="section" sx={{...carteSx, px: '24px', py: '16px', display: 'flex', flexDirection: 'column', gap: '14px'}}>
                        <Barre l={200} h={16} fond="#DDE2E8"/>
                        <LigneSquelette/><LigneSquelette/><LigneSquelette/>
                    </Box>
                </Box>
                <Box component="aside" sx={{flex: '1 1 320px', maxWidth: 400, display: 'flex', flexDirection: 'column', gap: '24px'}}>
                    <Box component="section" sx={{...carteSx, px: '20px', py: '16px', display: 'flex', flexDirection: 'column', gap: '12px'}}>
                        <Barre l={80} h={12} fond="#DDE2E8"/>
                        <Box sx={{width: '100%', height: 12, bgcolor: '#F0F2F5', borderRadius: '6px'}}/>
                        <Box sx={{width: '90%', height: 12, bgcolor: '#F0F2F5', borderRadius: '6px'}}/>
                        <Box sx={{width: '95%', height: 12, bgcolor: '#F0F2F5', borderRadius: '6px'}}/>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
